// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/workspaces/application-v2/web-client/src/models/defectsColors';
import model_2 from '/workspaces/application-v2/web-client/src/models/samples';
import model_3 from '/workspaces/application-v2/web-client/src/models/selectedCharts';
import model_4 from '/workspaces/application-v2/web-client/src/models/selectedDevice';
import model_5 from '/workspaces/application-v2/web-client/src/models/selectedImages';
import model_6 from '/workspaces/application-v2/web-client/src/models/selectedThreshold';
import model_7 from '/workspaces/application-v2/web-client/src/models/showSamplesDetails';
import model_8 from '/workspaces/application-v2/web-client/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'defectsColors', model: model_1 },
model_2: { namespace: 'samples', model: model_2 },
model_3: { namespace: 'selectedCharts', model: model_3 },
model_4: { namespace: 'selectedDevice', model: model_4 },
model_5: { namespace: 'selectedImages', model: model_5 },
model_6: { namespace: 'selectedThreshold', model: model_6 },
model_7: { namespace: 'showSamplesDetails', model: model_7 },
model_8: { namespace: '@@initialState', model: model_8 },
} as const
